import dskBg01 from '../../images/landings/01.png';
import dskBg02 from '../../images/landings/02.png';
import dskBg03 from '../../images/landings/03.png';
import dskBg04 from '../../images/landings/04.png';

import mobBg01 from '../../images/landings/mobile/01.png';
import mobBg02 from '../../images/landings/mobile/02.png';
import mobBg03 from '../../images/landings/mobile/03.png';
import mobBg04 from '../../images/landings/mobile/04.png';

export const dskBgs = [dskBg01, dskBg02, dskBg03, dskBg04];
export const mobBgs = [mobBg01, mobBg02, mobBg03, mobBg04]